/* eslint-disable prettier/prettier */
export default [
  '<div class="progressBar">',
    '<div class="progressBar-indicator js-indicatorBar"></div>',
    '<div class="progressBar-caption js-barCaption gray75"></div>',
  '</div>'
].join('');
